var React = require('react');

function Neutral (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"id":"defs3","key":0},React.createElement("style",{"id":"style5"},".cls-3{fill:#221f1f}")),React.createElement("g",{"id":"Pop1","key":1},[React.createElement("path",{"d":"M42.54 34.45a54.25 54.25 0 0119.12-4.52c5.34-.25 27.74-1.31 35.62 13.15 3.81 7 4.52 18.09-1 25.06-8 10.17-23.08 3.83-37.2 17.28a31 31 0 00-6.65 8.28C47 104 51.6 111 46.46 116.38c-4 4.1-11.57 5-16.12 2.15s-5.29-8.88-5.79-14.24c-2.81-30.14-5-53.69 10.65-65.71a30.17 30.17 0 017.34-4.13z","id":"path11","fill":"#fff","key":0}),React.createElement("circle",{"className":"cls-3","cx":"59.34","cy":"40.17","r":"1.55","id":"circle13","key":1}),React.createElement("circle",{"className":"cls-3","cx":"66.4","cy":"40.17","r":"1.55","id":"circle15","key":2})])]);
}

Neutral.defaultProps = {"id":"SVG_Pops","viewBox":"0 0 116 150","version":"1.1"};

module.exports = Neutral;

Neutral.default = Neutral;
